import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface PriceHistoryChartProps {
  data: Array<{
    month: string;
    average: number;
  }>;
}

export function PriceHistoryChart({ data }: PriceHistoryChartProps) {
  // Format data for display
  const formattedData = data.map((item) => ({
    ...item,
    month: new Date(item.month).toLocaleDateString("pt-BR", {
      month: "short",
      year: "numeric",
    }),
    average: Number(item.average),
  }));

  // Calculate min and max values for the Y axis
  const prices = formattedData.map((item) => item.average);
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);
  const padding = (maxPrice - minPrice) * 0.1; // Add 10% padding to top and bottom

  const formatCurrency = (value: number) => {
    if (value >= 1000000) {
      return `R$ ${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `R$ ${(value / 1000).toFixed(0)}k`;
    }
    return `R$ ${value.toFixed(0)}`;
  };

  return (
    <div className="w-full h-[300px] mt-4">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={formattedData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="month"
            stroke="#6b7280"
            tick={{ fill: "#6b7280", fontSize: 12 }}
          />
          <YAxis
            stroke="#6b7280"
            tick={{ fill: "#6b7280", fontSize: 12 }}
            tickFormatter={formatCurrency}
            domain={[minPrice - padding, maxPrice + padding]}
          />
          <Tooltip
            formatter={(value: number) => [
              formatCurrency(value),
              "Preço Médio",
            ]}
            contentStyle={{
              backgroundColor: "white",
              border: "1px solid #e5e7eb",
              borderRadius: "0.375rem",
              padding: "0.5rem",
            }}
          />
          <Line
            type="monotone"
            dataKey="average"
            stroke="#f58b14"
            strokeWidth={2}
            dot={{ fill: "#f58b14", strokeWidth: 2 }}
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
